export const CMS_URL = process.env.VUE_APP_API_CMS_URL
export const API_URL = process.env.VUE_APP_API_URL
export const RANK_URL = process.env.VUE_APP_API_RANK_URL
